export const copyToClipboard = async (data: string) => {
  try {
    await navigator.clipboard?.writeText(data);
  } catch (e: unknown) {
    console.log(`Could not copy address ${e instanceof Error ? e.message : String(e)}`);
  }
};

export const clearClipboard = () => {
  return copyToClipboard('');
};
